export default [
  {
    path: "/rtp/game",
    name: "game",
    component: () => import("@/views/rtp/game/GameList.vue"),
    meta: {
      // requiresAuth: true,
      action: "view",
      resource: "game",
      pageTitle: "Game",
      breadcrumb: [
        {
          text: "List",
          active: true
        }
      ]
    }
  },
]